import {HttpModelConverter} from "../../../../../../../core/converter/httpModel.converter";
import {PaymentRequestOnlineAttemptSummaryModel} from "../paymentRequestOnlineAttemptSummary.model";
import {Injectable} from "@angular/core";
import {PermissionsConverter} from "../../../../../../../common/converter/permissions.converter";
import {PaymentRequestSummaryConverter} from "../../../../api/entity/converter/paymentRequestSummary.converter";
import {
    LovValueSummaryConverter
} from "../../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class PaymentRequestOnlineAttemptSummaryConverter extends HttpModelConverter<PaymentRequestOnlineAttemptSummaryModel> {

    constructor(private permissionsConverter: PermissionsConverter,
                private paymentRequestSummaryConverter: PaymentRequestSummaryConverter,
                private lovValueConverter: LovValueSummaryConverter) {
        super();
    }

    protected createInstance(): PaymentRequestOnlineAttemptSummaryModel {
        return new PaymentRequestOnlineAttemptSummaryModel();
    }

    protected enrichObject(result: PaymentRequestOnlineAttemptSummaryModel, src: PaymentRequestOnlineAttemptSummaryModel) {
        result.permissions = this.permissionsConverter.convert(src.permissions);
        result.paymentRequest = this.paymentRequestSummaryConverter.convert(src.paymentRequest);
        result.status = this.lovValueConverter.convert(src.status);
    }
}
